import type { CalculatedColumn, CalculatedColumnOrColumnGroup } from '../types';

export * from './colSpanUtils';
export * from './domUtils';
export * from './eventUtils';
export * from './keyboardUtils';
export * from './rangeUtils';
export * from './renderMeasuringCells';
export * from './selectedCellUtils';
export * from './styleUtils';
export { getCell } from './cell';

export const { min, max, floor, sign, abs } = Math;

export function assertIsValidKeyGetter<R, K extends React.Key>(keyGetter: unknown): asserts keyGetter is (row: R) => K {
  if (typeof keyGetter !== 'function') {
    throw new Error('Please specify the rowKeyGetter prop to use selection');
  }
}

export function clampColumnWidth<R, SR>(width: number, { minWidth, maxWidth }: CalculatedColumn<R, SR>): number {
  const clamped = max(width, minWidth);

  // ignore maxWidth if it less than minWidth
  if (typeof maxWidth === 'number' && maxWidth >= minWidth) {
    return min(clamped, maxWidth);
  }

  return clamped;
}

export function getHeaderCellRowSpan<R, SR>(column: CalculatedColumnOrColumnGroup<R, SR>, rowIdx: number): number {
  return column.parent === undefined ? rowIdx : column.level - column.parent.level;
}
